import AddressInput from "../../components/forms/AddressInput";
import languages from "../../data/languages";

const languageProficiencyOptions = [
  "Basic",
  "Conversational",
  "Fluent",
  "Native",
];

function PersonalInformation({
  formData,
  handleChange,
  handleAddressChange,
  handleEmergencyContactChange,
  isLanguageFormOpen,
  editingLanguageIndex,
  languageDraft,
  openAddLanguageForm,
  openEditLanguageForm,
  handleLanguageDraftChange,
  saveLanguage,
  cancelLanguageForm,
  removeLanguage,
  handleSubmit,
  isSaving,
  message,
  error,
}) {
  return (
    <section className="profile-card">
      {error && (
        <p className="auth-error" role="alert">
          {error}
        </p>
      )}

      {message && (
        <p className="auth-success" role="status">
          {message}
        </p>
      )}

      <form
        className="account-form registration-grid"
        onSubmit={handleSubmit}
      >
        {/* Personal information */}
        <div className="form-field">
          <label htmlFor="profile-first-name">
            First name *
          </label>

          <input
            id="profile-first-name"
            name="firstName"
            type="text"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="profile-last-name">
            Last name *
          </label>

          <input
            id="profile-last-name"
            name="lastName"
            type="text"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="profile-email">
            Email address *
          </label>

          <input
            id="profile-email"
            name="email"
            type="email"
            value={formData.email}
            disabled
          />
        </div>

        <div className="form-field">
          <label htmlFor="profile-phone">
            Phone number *
          </label>

          <input
            id="profile-phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="profile-date-of-birth">
            Date of birth *
          </label>

          <input
            id="profile-date-of-birth"
            name="dateOfBirth"
            type="date"
            value={formData.dateOfBirth}
            onChange={handleChange}
            max={new Date().toISOString().slice(0, 10)}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="profile-profession">
            Profession *
          </label>

          <select
            id="profile-profession"
            name="profession"
            value={formData.profession}
            onChange={handleChange}
            required
          >
            <option value="">
              Select profession
            </option>

            <option value="Registered Nurse">
              Registered Nurse
            </option>

            <option value="Registered Practical Nurse">
              Registered Practical Nurse
            </option>

            <option value="Licensed Practical Nurse">
              Licensed Practical Nurse
            </option>

            <option value="Nurse Practitioner">
              Nurse Practitioner
            </option>

            <option value="Personal Support Worker">
              Personal Support Worker
            </option>

            <option value="Health Care Assistant">
              Health Care Assistant
            </option>

            <option value="Respiratory Therapist">
              Respiratory Therapist
            </option>
          </select>
        </div>

        {/* Address */}

        <AddressInput
  address={formData.address}
  city={formData.city}
  province={formData.province}
  postalCode={formData.postalCode}
  country={formData.country}
  onChange={handleAddressChange}
/>

        {/* Emergency contact */}
        <div className="registration-grid-full profile-subsection">
          <div className="profile-subsection-header">
            <h3>Emergency contact (Optional)</h3>

            <p>
              Add someone Zeth Health may contact in an
              emergency.
            </p>
          </div>
        </div>

        <div className="form-field">
          <label htmlFor="emergency-contact-name">
            Contact name
          </label>

          <input
            id="emergency-contact-name"
            name="name"
            type="text"
            value={
              formData.emergencyContact?.name || ""
            }
            onChange={handleEmergencyContactChange}
          />
        </div>

        <div className="form-field">
          <label htmlFor="emergency-contact-relationship">
            Relationship
          </label>

          <input
            id="emergency-contact-relationship"
            name="relationship"
            type="text"
            value={
              formData.emergencyContact?.relationship ||
              ""
            }
            onChange={handleEmergencyContactChange}
          />
        </div>

        <div className="form-field">
          <label htmlFor="emergency-contact-phone">
            Contact phone number
          </label>

          <input
            id="emergency-contact-phone"
            name="phone"
            type="tel"
            value={
              formData.emergencyContact?.phone || ""
            }
            onChange={handleEmergencyContactChange}
          />
        </div>

        {/* Languages */}
        {/* Languages */}
<div className="registration-grid-full profile-subsection">
  <div className="profile-subsection-header">
    <div>
      <h3>Languages (Optional)</h3>

      <p>
        You can add one or more languages.
      </p>
    </div>

    {!isLanguageFormOpen && (
      <button
        type="button"
        className="secondary-button"
        onClick={openAddLanguageForm}
      >
        + Add Language
      </button>
    )}
  </div>
</div>

{formData.languages.length === 0 &&
  !isLanguageFormOpen && (
    <div className="registration-grid-full">
      <p className="empty-form-message">
        No languages added yet.
      </p>
    </div>
  )}

{formData.languages.length > 0 && (
  <div className="registration-grid-full language-list">
    {formData.languages.map(
      (languageItem, index) => (
        <div
          className="language-summary-row"
          key={`${languageItem.language}-${index}`}
        >
          <div className="language-summary-details">
            <strong>
              {languageItem.language}
            </strong>

            <span>
              {languageItem.proficiency}
            </span>
          </div>

          <details className="language-actions-menu">
            <summary
              aria-label={`Actions for ${languageItem.language}`}
            >
              ⋮
            </summary>

            <div className="language-actions-dropdown">
              <button
                type="button"
                onClick={() =>
                  openEditLanguageForm(index)
                }
              >
                Edit
              </button>

              <button
                type="button"
                className="language-remove-action"
                onClick={() =>
                  removeLanguage(index)
                }
              >
                Remove
              </button>
            </div>
          </details>
        </div>
      )
    )}
  </div>
)}

{isLanguageFormOpen && (
  <div className="registration-grid-full language-form-card">
    <div className="form-field">
      <label htmlFor="language-draft-name">
        Language
      </label>

      <select
        id="language-draft-name"
        name="language"
        value={languageDraft.language}
        onChange={handleLanguageDraftChange}
      >
        <option value="">
          Select language
        </option>

        {languages.map((language) => (
          <option
            key={language}
            value={language}
          >
            {language}
          </option>
        ))}
      </select>
    </div>

    <div className="form-field">
      <label htmlFor="language-draft-proficiency">
        Proficiency
      </label>

      <select
        id="language-draft-proficiency"
        name="proficiency"
        value={languageDraft.proficiency}
        onChange={handleLanguageDraftChange}
      >
        <option value="">
          Select proficiency
        </option>

        {languageProficiencyOptions.map(
          (option) => (
            <option
              key={option}
              value={option}
            >
              {option}
            </option>
          )
        )}
      </select>
    </div>

    <div className="language-form-actions">
      <button
        type="button"
        className="secondary-button"
        onClick={cancelLanguageForm}
      >
        Cancel
      </button>

      <button
        type="button"
        className="primary-button"
        onClick={saveLanguage}
      >
        {editingLanguageIndex !== null
          ? "Update Language"
          : "Add Language"}
      </button>
    </div>
  </div>
)}

        <div className="save-profile-container registration-grid-full">
          <button
            type="submit"
            className="primary-button registration-submit save-profile-button"
            disabled={isSaving}
          >
            {isSaving
              ? "Saving..."
              : "Save Profile"}
          </button>
        </div>
      </form>
    </section>
  );
}

export default PersonalInformation;